import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function LegalNoticePage() {
  const {
    t
  } = useLanguage();
  return <div className="w-full bg-white min-h-screen pb-32" data-id="element-388">
      <div className="bg-corporate-dark text-white py-20 px-4" data-id="element-389">
        <div className="max-w-4xl mx-auto text-center mt-10" data-id="element-390">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-heading font-bold mb-6 tracking-tight" data-id="element-391">
            {t('footer.legal')}
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="text-lg text-gray-300 max-w-2xl mx-auto font-light" data-id="element-392">
            Información legal sobre el titular del sitio web, condiciones de uso
            y propiedad intelectual.
          </motion.p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-393">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-12" data-id="element-394">
          {/* Sección 1 */}
          <section data-id="element-395">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-396">
              1. Identificación del Titular
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-397">
              <p data-id="element-398">
                En cumplimiento con el deber de información establecido en la
                normativa vigente, se comunica que el titular de este sitio web
                es{' '}
                <strong className="text-corporate-dark font-medium" data-id="element-399">
                  SmartImport Internacional
                </strong>
                , empresa dedicada a la importación y distribución internacional
                de materiales arquitectónicos de alta gama, incluyendo suelos
                SPC, paneles decorativos, puertas WPC, sistemas de aluminio y
                césped artificial.
              </p>
              <p data-id="element-400">
                Domicilio social: [Dirección por confirmar]
                <br data-id="element-401" />
                C.I.F.: [Número por confirmar]
                <br data-id="element-402" />
                Correo electrónico de contacto:{' '}
                <strong className="text-corporate-dark font-medium" data-id="element-403">
                  info@smartimport.com
                </strong>
              </p>
              <p data-id="element-404">
                SmartImport Internacional opera como proveedor B2B, ofreciendo
                sus productos y servicios a distribuidores profesionales,
                empresas constructoras, estudios de arquitectura y profesionales
                del sector de la construcción y el interiorismo.
              </p>
            </div>
          </section>

          {/* Sección 2 */}
          <section data-id="element-405">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-406">
              2. Condiciones de Uso del Sitio Web
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-407">
              <p data-id="element-408">
                El acceso y navegación por este sitio web atribuye la condición
                de Usuario e implica la aceptación plena y sin reservas de todas
                las disposiciones incluidas en este Aviso Legal, así como de
                cualesquiera otras disposiciones legales que resulten de
                aplicación.
              </p>
              <p data-id="element-409">
                SmartImport Internacional proporciona a través de este sitio web
                información sobre sus productos, servicios, catálogos técnicos y
                documentación descargable. El Usuario se compromete a hacer un
                uso adecuado de los contenidos y servicios ofrecidos,
                absteniéndose de emplearlos para actividades ilícitas, ilegales
                o contrarias a la buena fe y al orden público.
              </p>
              <p data-id="element-410">
                El Usuario se compromete a no realizar ninguna acción que pueda
                dañar, inutilizar, sobrecargar o deteriorar el sitio web o
                impedir el normal uso y disfrute del mismo por parte de otros
                usuarios.
              </p>
            </div>
          </section>

          {/* Sección 3 */}
          <section data-id="element-411">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-412">
              3. Propiedad Intelectual e Industrial
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-413">
              <p data-id="element-414">
                Todos los contenidos de este sitio web, incluyendo a título
                enunciativo pero no limitativo: textos, fotografías, imágenes de
                productos, gráficos, logotipos, iconos, diseños, catálogos,
                fichas técnicas, documentos descargables, software y cualquier
                otro material, son propiedad de SmartImport Internacional o de
                sus legítimos licenciantes y están protegidos por las leyes
                nacionales e internacionales de propiedad intelectual e
                industrial.
              </p>
              <p data-id="element-415">
                Queda expresamente prohibida la reproducción total o parcial de
                los contenidos de este sitio web, su distribución, comunicación
                pública, transformación o cualquier otra forma de explotación,
                por cualquier procedimiento, sin la autorización previa y por
                escrito de SmartImport Internacional.
              </p>
              <p data-id="element-416">
                Las marcas, nombres comerciales y signos distintivos que
                aparecen en este sitio web son propiedad de SmartImport
                Internacional. El acceso al sitio web no otorga al Usuario
                derecho alguno sobre dichas marcas, nombres comerciales y/o
                signos distintivos.
              </p>
            </div>
          </section>

          {/* Sección 4 */}
          <section data-id="element-417">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-418">
              4. Exclusión de Garantías y Responsabilidad
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-419">
              <p data-id="element-420">
                SmartImport Internacional no se hace responsable, en ningún
                caso, de los daños y perjuicios de cualquier naturaleza que
                pudieran derivarse del acceso o uso de este sitio web,
                incluyendo pero no limitándose a:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-421">
                <li data-id="element-422">Errores u omisiones en los contenidos publicados.</li>
                <li data-id="element-423">
                  Falta de disponibilidad, mantenimiento o interrupción del
                  sitio web.
                </li>
                <li data-id="element-424">
                  Presencia de virus o programas maliciosos en los contenidos.
                </li>
                <li data-id="element-425">
                  Uso ilícito, negligente o fraudulento del sitio web por parte
                  de los usuarios.
                </li>
                <li data-id="element-426">
                  Inexactitud, falta de actualización o inadecuación de los
                  contenidos a las necesidades específicas del Usuario.
                </li>
              </ul>
              <p data-id="element-427">
                La información sobre productos, especificaciones técnicas y
                materiales se proporciona con fines orientativos y puede estar
                sujeta a cambios sin previo aviso. SmartImport Internacional
                recomienda contactar directamente para confirmar
                especificaciones antes de tomar decisiones de compra.
              </p>
              <p data-id="element-428">
                Este sitio web puede contener enlaces a sitios web de terceros.
                SmartImport Internacional no se hace responsable del contenido,
                políticas de privacidad o prácticas de dichos sitios web
                externos.
              </p>
            </div>
          </section>

          {/* Sección 5 */}
          <section data-id="element-429">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-430">
              5. Modificaciones
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-431">
              <p data-id="element-432">
                SmartImport Internacional se reserva el derecho de efectuar, sin
                previo aviso, las modificaciones que considere oportunas en este
                sitio web, pudiendo cambiar, suprimir o añadir tanto los
                contenidos y servicios que se presten a través del mismo como la
                forma en que éstos aparezcan presentados o localizados.
              </p>
              <p data-id="element-433">
                Asimismo, SmartImport Internacional podrá modificar las
                presentes condiciones de uso en cualquier momento. Las
                condiciones modificadas entrarán en vigor desde el momento de su
                publicación en el sitio web.
              </p>
            </div>
          </section>

          {/* Sección 6 */}
          <section data-id="element-434">
            <h2 className="text-2xl font-heading font-bold text-corporate-dark mb-4" data-id="element-435">
              6. Legislación Aplicable y Jurisdicción
            </h2>
            <div className="text-gray-600 font-light leading-relaxed space-y-4" data-id="element-436">
              <p data-id="element-437">
                El presente Aviso Legal se rige en todos y cada uno de sus
                extremos por la legislación vigente. Para la resolución de
                cualquier controversia que pudiera derivarse del acceso o uso de
                este sitio web, SmartImport Internacional y el Usuario acuerdan
                someterse a los Juzgados y Tribunales competentes del domicilio
                de SmartImport Internacional, renunciando expresamente a
                cualquier otro fuero que pudiera corresponderles.
              </p>
            </div>
          </section>

          <div className="border-t border-gray-200 pt-8 mt-12" data-id="element-438">
            <p className="text-sm text-gray-400 font-light" data-id="element-439">
              Última actualización: Marzo 2026
            </p>
          </div>
        </motion.div>
      </div>
    </div>;
}